<div class="link-button" *ngIf="loading">
  <div class="invite" *ngIf="showInvite">
    <button class="btn copy-button ml-auto" (click)="handleInvite(false)">
      <i class="fa fa-times"></i>
    </button>
    <h3 class="font-weight-bold mb-2">ESTÁ GOSTANDO?</h3>
    <h5 class="mb-2">Você pode nos indicar e ganhar benefícios!</h5>
    <p>
      Seria incrível se você pudesse compartilhar sua experiência conosco nas redes sociais da <a href="https://www.instagram.com/escrithaoficial/" target="_blank">ESCRITHA</a>.
    </p>
    <p>Estamos contentes por você estar utilizando nossa plataforma; ficaríamos ainda mais felizes se seus amigos também viessem.</p>
    <div class="d-flex flex-column">

      <h4 class="mt-4">Este é seu link:</h4>
      <div class="d-flex flex-row align-items-center pb-2">
        <a class="link-adress" target="_blank" href="{{invitationUrl}}">{{invitationUrl}}</a>
        <button class="btn copy-button" (click)="stringToClipboard(invitationUrl)">
          <svg *ngIf="!showCheckmark" class="checkmark" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
          </svg>
  
          <svg  *ngIf="showCheckmark" class="checkmark" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
          </svg>
          
        </button>
        
      </div>
    </div>
  </div>

  <div class="button-div">
    <button class="square" type="button" (click)="handleInvite(!showInvite)" [class.clicked]="showInvite">
      <span><i class="fa fa-spinner" aria-hidden="true"></i> Indique um amigo</span>
    </button>
  </div>
  
</div>